import { call, put, takeLatest } from 'redux-saga/effects';
import {
  setNoteTemplate,
  createNoteTemplate,
  deleteNoteTemplate,
  getNoteTemplates,
  removeNoteTemplate,
  setNoteTemplates,
  setUpdatedNoteTemplate,
  updateNoteTemplate
} from './noteTemplates.redux';
import { openNotificationMessage } from 'shared/utils/NotificationMessages';
import { NotificationMessages } from 'shared/enums';
import { TAction } from 'shared/types';
import NoteTemplateService from 'shared/services/NoteTemplateService';
import {
  INoteTemplate,
  INoteTemplateCreate,
  INoteTemplateUpdate
} from 'shared/interfaces/noteTemplate.interface';

function* createNoteTemplateSaga({ payload }: TAction<INoteTemplateCreate>) {
  try {
    const result: INoteTemplate = yield call(
      NoteTemplateService.createNoteTemplate,
      payload
    );

    yield put(setNoteTemplate(result));
    yield openNotificationMessage({
      type: NotificationMessages.Success,
      title: 'Success',
      message: 'Note template was successfully added.'
    });
  } catch (error) {
    console.log('error', error);
    yield openNotificationMessage({
      type: NotificationMessages.Error,
      title: 'Error',
      message: 'Note template creation was unsuccesful.'
    });
  }
}

function* getNoteTemplatesSaga() {
  try {
    const result: INoteTemplate[] = yield call(
      NoteTemplateService.getNoteTemplates
    );

    yield put(setNoteTemplates(result));
  } catch (error) {
    console.log('error', error);
  }
}

function* deleteNoteTemplateSaga({ payload }: TAction<string>) {
  try {
    yield call(NoteTemplateService.deleteNoteTemplates, payload);
    yield put(removeNoteTemplate(payload));
    yield openNotificationMessage({
      type: NotificationMessages.Success,
      title: 'Success',
      message: 'Note template was successfully deleted.'
    });
  } catch (error: any) {
    console.log('error', error);
    yield openNotificationMessage({
      type: NotificationMessages.Error,
      title: 'Error',
      message:
        error?.response?.data.message || 'Unable to delete note template.'
    });
  }
}

function* updateNoteTemplateSaga({ payload }: TAction<INoteTemplateUpdate>) {
  try {
    const result: INoteTemplate = yield call(
      NoteTemplateService.updateNoteTemplates,
      payload
    );

    yield put(setUpdatedNoteTemplate(result));
    yield openNotificationMessage({
      type: NotificationMessages.Success,
      title: 'Success',
      message: 'Note template was successfully added.'
    });
  } catch (error) {
    console.log('error', error);
    yield openNotificationMessage({
      type: NotificationMessages.Error,
      title: 'Error',
      message: 'Note template creation was unsuccesful.'
    });
  }
}

function* Projects() {
  yield takeLatest(createNoteTemplate.type, createNoteTemplateSaga);
  yield takeLatest(getNoteTemplates.type, getNoteTemplatesSaga);
  yield takeLatest(deleteNoteTemplate.type, deleteNoteTemplateSaga);
  yield takeLatest(updateNoteTemplate.type, updateNoteTemplateSaga);
}

export default Projects;
